import { createRoot } from 'react-dom/client'
import { Helmet, HelmetProvider } from 'react-helmet-async'
// Attribution first: it reads the landing URL before any route redirect rewrites it (src/lib/attribution.ts).
import './lib/attribution'
import App from './App.tsx'
import './index.css'

// react-helmet-async defers all head writes (title/meta/canonical) to a single
// requestAnimationFrame by default. Renderers that never paint a frame — the
// bot-prerender worker, Google's Web Rendering Service, hidden/headless tabs —
// never fire rAF, so crawlers saw only the static index.html head on every
// route. Forcing synchronous commits keeps per-route SEO tags visible to bots.
// (Set globally here; per-<Helmet> defer props would re-enable the bug.)
Helmet.defaultProps = { ...Helmet.defaultProps, defer: false }

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
